<ng-template [ngIf]="!!formViewData.formSpec && ((legacyWebUI && url3_5) || (uiCompare && url3_5))">
  <p *ngIf="unsupportedPattern && !isProduction" style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
    CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
  </p>
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
    (titleChanged)="onTitleChanged($event)"
    ></lm-html-url-doc>
</ng-template>

<ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent; else ToolbarMarkup">
  <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
    <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
  </soho-header>
</ng-container>

<div soho-busyindicator
    *ngIf="(!legacyWebUI || uiCompare)"
    [ngClass]="{'scrollable' : isMingleInbox || hideTitleManageScroll}"
    [style.height]="'100%'"
    [text]="' '"
    [displayDelay]="0"
    [blockUI]="true"
    [transparentOverlay]="false"
    [timeToComplete]="this.uiLoadingIndicatorTimeout"
    [class.isMingleWidget]="isMingleWidget"
    [class.hide-title-or-mingle-inbox]="(isMingleInbox || hideTitleManageScroll) && !isPageContextForm"
    [class.page-context-form]="!(isMingleInbox || hideTitleManageScroll) && isPageContextForm"
>
  <ng-template [ngIf]="(formViewData.formSpec && formViewData.dataView) ">
    <div id='{{formSpec?.busFormSpec?.name}}' class="lmc" [class.lm-form-content-wrapper]="isCompositeForm || isActionFormWithSections">
      <ng-template [ngIf]="formViewData.dataView">
        <lm-form-content #LMFormContentComponent
          *ngIf="!hideLayout"
          [formUrlInfo]="formUrlInfo"
          [formSpec]="formViewData.formSpec"
          [formOptions]="formOptions"
          [specFields]="specFields"
          [layout]="layout"
          [model]="model"
          [placeHolder]="placeHolder"
          [formState]="formState"
          [formPersonalization]="formPersonalization"
          [fromDataView]="fromDataView"
          [columnarText]="columnarText"
          [parentIsModal]="parentIsModal"
          [instanceId]="instanceId"
          (searchButtonClicked)="onSearchClicked($event)"
          (clearSearchButtonClicked)="onClearSearchClicked($event)"
          (fieldEvent)="onFieldEvent($event)"
          (stepPanelEvent)="onStepPanelEvent($event)"
          (contentModified)="onContentModified($event)"
          (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
          (sendContextMessageEvent)="onSendContextMessageEvent($event)"
          (specialActionsToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
          (panelTransactionEvent)="onPanelTransactionEvent($event)"
          (matrixActionEvent)="onRunMatrixActionEvent($event)"
          (contentLoadEvent)="onContentLoadEvent($event)"
        ></lm-form-content>
      </ng-template>
    </div>
  </ng-template>
</div>

<div #dialogPlaceholder id="lmFormDialogPlaceholder" class="lmDialogPlaceholder"></div>

<ng-template #ToolbarMarkup>
  <!--  <ng-container *ngIf="hideTitleBar">   -->
  <lm-toolbar *ngIf="formSpec && showToolbarOnForm && (!legacyWebUI || uiCompare)"
      [inHeader]="isRouterOutletRootComponent && bannerInRoute"
      [toolbarIdPrefix]="this.formSpec.busFormSpec.name"
      [automationId]="this.formSpec.automationId"
      [sectionTitle]="formTitle"
      [buttons]="toolbarButtons | async"
      [moreMenuSettings]="toolbarMoreMenuSettings"
      [class.hideTitleToolbar]="true"
      [class.implements-cart-view]="formSpec.busFormSpec.implementsCartView"
      [class.banner-in-route]="true"

      (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"

      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"

  ></lm-toolbar>
  <!--  </ng-container>  -->
</ng-template>
